import { Link, useNavigate } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
import moment from 'moment'
import Toaster from "../../components/toaster";
import getAvailabilityBlocker from "./availabilityBlocker";

const OneWayAvailabilities = () => {
    let navigate = useNavigate();
    const isMobileView = useIsMobile();
    const [availabilitiesList, setAvailabilitiesList] = useState([])
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)
    const [blocker, setBlocker] = useState(null) // why the vendor cannot add availability
    const [leadsSheet, setLeadsSheet] = useState(null) // availability whose leads are shown
    const [leadsList, setLeadsList] = useState([])
    const [leadsLoading, setLeadsLoading] = useState(false)

    const openLeads = async (item) => {
        setLeadsSheet(item)
        setLeadsList([])
        setLeadsLoading(true)
        try {
            const response = await services.Vendor.GET_INQUIRIES_BY_AVAILABILITY_ID(item.id, {})
            setLeadsList(response?.data?.inquiries || [])
        } catch (error) {
            console.log(error)
        } finally {
            setLeadsLoading(false)
        }
    }

    const getAvailabilitiesHandler = async () => {
        setLoading(true)
        try {
            const response = await services.Vendor.GET_ALL_ONE_WAY_AVAILABILITIES({ page, limit });
            // Handle response structure with count and rows
            if (response.data?.rows) {
                setAvailabilitiesList(response.data.rows || [])
                // Calculate total pages from count
                if (response.data.count) {
                    const calculatedPages = Math.ceil(response.data.count / limit)
                    setTotalPages(calculatedPages || 1)
                }
            } else if (Array.isArray(response.data)) {
                // Fallback if response is directly an array
                setAvailabilitiesList(response.data || [])
            } else {
                setAvailabilitiesList([])
            }
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to fetch availabilities",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        } finally {
            setLoading(false)
        }
    }

    const deleteAvailabilityHandler = async (id) => {
        if (!window.confirm("Are you sure you want to delete this availability?")) {
            return;
        }
        try {
            const response = await services.Vendor.DELETE_ONE_WAY_AVAILABILITY(id);
            setToaster({
                type: "success",
                title: "Success",
                text: "Availability deleted successfully",
                visiblity: "show",
            });
            getAvailabilitiesHandler()
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to delete availability",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        }
    }

    const toggleActivationHandler = async (id, currentStatus) => {
        try {
            const response = await services.Vendor.TOGGLE_ONE_WAY_AVAILABILITY_ACTIVATION(id, { isActive: !currentStatus });
            setToaster({
                type: "success",
                title: "Success",
                text: "Availability updated successfully",
                visiblity: "show",
            });
            getAvailabilitiesHandler()
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to update availability",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        }
    }

    const handleAddAvailabilityClick = async (e) => {
        e?.preventDefault();
        try {
            const { data } = await services.Vendor.GET_ONE_WAY_ELIGIBILITY();
            const nextBlocker = getAvailabilityBlocker(data);
            if (nextBlocker) {
                setBlocker(nextBlocker);
                return;
            }
            navigate('/oneWayAvailabilities/add');
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to check eligibility",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        }
    }

    const handleCloseModal = () => {
        setBlocker(null);
    }

    useEffect(() => {
        getAvailabilitiesHandler()
    }, [page])

    // Handle body scroll lock when modal is open
    useEffect(() => {
        if (blocker) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [blocker])

    const blockerModal = blocker && (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
            tabIndex="-1"
            role="dialog"
            onClick={handleCloseModal}
        >
            <div className="modal-dialog modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{blocker.title}</h5>
                        <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <p>{blocker.text}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                        {blocker.actionTo && (
                            <button type="button" className="btn theme-btn" onClick={() => navigate(blocker.actionTo)}>{blocker.actionLabel}</button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )

    if (isMobileView) {
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Empty-return trips</div>
                        <div className="nm" style={{ fontSize: 22 }}>One-Way Availabilities</div>
                    </div>

                    {availabilitiesList && availabilitiesList.length ? availabilitiesList.map((item, i) => (
                        <div className="mlux-card" style={{ padding: 14, marginBottom: 12 }} key={i} data-rise="2">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                                <div className="lt">{item.vendorCar?.Car?.name || item.vendorCar?.car?.name} ({item.vendorCar?.Car?.brand || item.vendorCar?.car?.brand})</div>
                                <span className={`mlux-badge ${item.isCompleted ? 'done' : item.isActive ? 'ok' : 'no'}`}>{item.isCompleted ? 'Completed' : item.isActive ? 'Active' : 'Inactive'}</span>
                            </div>
                            <div className="mlux-date"><i className="far fa-calendar"></i>{moment(item.tripDate).format('ddd, DD MMM')}</div>
                            <div className="mlux-route">
                                <div className="pt from"><small>From</small>{item.from?.full_address || 'N/A'}</div>
                                <div className="pt to"><small>To</small>{item.to?.full_address || 'N/A'}</div>
                            </div>
                            {(() => {
                                const pk = Number(item.vendorCar?.perKmCharge || item.vendorCar?.Car?.perKmCharge || 0);
                                const f = item.isCompleted && item.estimatedFare != null ? Math.round(item.estimatedFare) : item.distanceMeters && pk ? Math.round((item.distanceMeters / 1000) * pk) : null;
                                return f != null ? <div className="mlux-date" style={{ color: '#16a34a', fontWeight: 800 }}><i className="fas fa-indian-rupee-sign"></i> Est. fare ₹{f}</div> : null;
                            })()}
                            <div className="mlux-rowbtns">
                                <button onClick={() => openLeads(item)}><i className="far fa-user-group"></i> Leads ({item.leadsCount || 0})</button>
                                {!item.isCompleted && <button onClick={() => toggleActivationHandler(item.id, item.isActive)}><i className={`far fa-${item.isActive ? 'pause' : 'play'}`}></i> {item.isActive ? 'Pause' : 'Activate'}</button>}
                                {!item.isCompleted && <button className="danger" style={{ flex: '0 0 46px' }} onClick={() => deleteAvailabilityHandler(item.id)}><i className="far fa-trash"></i></button>}
                            </div>
                        </div>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="2">
                            <div className="ic"><i className="fas fa-route"></i></div>
                            <h4>No availabilities</h4>
                            <p>List an empty-return trip so riders can find you.</p>
                            <Link to="/oneWayAvailabilities/add" onClick={handleAddAvailabilityClick} className="mlux-btn ghost" style={{ textDecoration: 'none' }}><i className="fas fa-plus"></i> Add availability</Link>
                        </div>
                    )}
                </main>
                <Link to="/oneWayAvailabilities/add" onClick={handleAddAvailabilityClick} className="mlux-fab"><i className="fas fa-plus"></i></Link>
                <MobileFooter />
                {blockerModal}
                {leadsSheet && (
                    <div className="mlux-sheet-backdrop" onClick={() => setLeadsSheet(null)}>
                        <div className="mlux-sheet" onClick={(e) => e.stopPropagation()}>
                            <div className="mlux-sheet-grip" />
                            <h3>Leads &amp; bookings</h3>
                            <p>{leadsSheet.from?.full_address || 'From'} → {leadsSheet.to?.full_address || 'To'}</p>
                            {leadsLoading ? (
                                <div className="mlux-empty" style={{ padding: 20 }}><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading…</h4></div>
                            ) : leadsList.length === 0 ? (
                                <div className="mlux-empty" style={{ padding: 20 }}><div className="ic"><i className="far fa-user-group"></i></div><h4>No leads yet</h4><p>Riders who contact you appear here.</p></div>
                            ) : (
                                <div style={{ maxHeight: '52vh', overflowY: 'auto' }}>
                                    {leadsList.map((lead) => {
                                        const phone = lead.contactNumber || lead.user?.phoneNumber || '';
                                        return (
                                            <div className="mlux-card mlux-contact" key={lead.id} style={{ marginBottom: 10 }}>
                                                <div className="ci">
                                                    <div className="av"><i className="far fa-user"></i></div>
                                                    <div className="tx">
                                                        <div className="nm">{lead.userName || lead.user?.firstName || 'Rider'}
                                                            {lead.confirmed
                                                                ? <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 800, color: '#16a34a', background: 'rgba(22,163,74,0.12)', padding: '2px 8px', borderRadius: 999 }}>Confirmed · {lead.passengerCount || 1} pax</span>
                                                                : <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 800, color: '#64748b', background: 'rgba(100,116,139,0.12)', padding: '2px 8px', borderRadius: 999 }}>Lead</span>}
                                                        </div>
                                                        <div className="ph">{phone || 'No number'}</div>
                                                        {lead.createdAt && <div className="ph" style={{ fontSize: 11, opacity: 0.8 }}><i className="far fa-clock"></i> {moment(lead.createdAt).format('DD MMM YYYY, hh:mm A')}</div>}
                                                    </div>
                                                </div>
                                                {phone && <a className="mlux-callbtn sm" href={`tel:${String(phone).replace(/[^\d+]/g, '')}`}><i className="fas fa-phone"></i></a>}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            <button className="mlux-btn ghost" style={{ marginTop: 12 }} onClick={() => setLeadsSheet(null)}>Close</button>
                        </div>
                    </div>
                )}
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />

            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">One-Way Availabilities</h4>
                                                <div class="user-profile-card-header-right">
                                                    <div class="user-profile-search">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" placeholder="Search..." />
                                                            <i class="far fa-search"></i>
                                                        </div>
                                                    </div>
                                                    <button onClick={() => handleAddAvailabilityClick()} class="theme-btn"><i class="far fa-plus"></i> Add Availability</button>
                                                </div>
                                            </div>
                                            {loading ? (
                                                <div class="text-center py-5">
                                                    <p>Loading availabilities...</p>
                                                </div>
                                            ) : (
                                                <div class="table-responsive">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th>From</th>
                                                                <th>To</th>
                                                                <th>Trip Date</th>
                                                                <th>Car</th>
                                                                <th>Contact</th>
                                                                <th>Leads</th>
                                                                {/* <th>Status</th> */}
                                                                <th>Active</th>
                                                                <th>Created Date</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {availabilitiesList && availabilitiesList.length ? availabilitiesList.map((item, indx) => {
                                                                return (
                                                                    <tr key={indx}>
                                                                        <td>
                                                                            <span>{item.from?.full_address || 'N/A'}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{item.to?.full_address || 'N/A'}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{moment(item.tripDate).format('DD-MM-YYYY')}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{item.vendorCar?.Car?.name || item.vendorCar?.car?.name || 'N/A'} ({item.vendorCar?.Car?.brand || item.vendorCar?.car?.brand || 'N/A'})</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{item.contactNumber}</span>
                                                                        </td>
                                                                        <td>
                                                                            <Link to={`/oneWayAvailabilities/${item.id}`} title="View leads"
                                                                                class={`badge ${item.leadsCount ? 'badge-primary' : 'bg-secondary'}`}>
                                                                                <i class="far fa-user-group me-1"></i>{item.leadsCount || 0}
                                                                            </Link>
                                                                        </td>
                                                                        {/* <td>
                                                                            <span class={`badge badge-${item.status ? 'success' : 'danger'}`}>
                                                                                {item.status ? 'Active' : 'Inactive'}
                                                                            </span>
                                                                        </td> */}
                                                                        <td>
                                                                            <span class={`badge badge-${item.isCompleted ? 'primary' : item.isActive ? 'success' : 'danger'}`}>
                                                                                {item.isCompleted ? 'Completed' : item.isActive ? 'Active' : 'Inactive'}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{moment(item.createdAt).format('DD-MM-YYYY, hh:mm')}</span>
                                                                        </td>
                                                                        <td>
                                                                            <Link to={`/oneWayAvailabilities/${item.id}`}
                                                                                class="btn btn-outline-secondary btn-sm rounded-2"
                                                                                data-bs-toggle="tooltip" title="View Details"><i
                                                                                    class="far fa-eye"></i></Link>
                                                                            {!item.isCompleted && <>
                                                                            <Link to={`/oneWayAvailabilities/edit/${item.id}`}
                                                                                class="btn ms-2 btn-outline-secondary btn-sm rounded-2"
                                                                                data-bs-toggle="tooltip" title="Edit"><i
                                                                                    class="far fa-pencil"></i></Link>
                                                                            <button
                                                                                onClick={() => toggleActivationHandler(item.id, item.isActive)}
                                                                                class={`btn ms-2 btn-outline-${item.isActive ? 'warning' : 'success'} btn-sm rounded-2`}
                                                                                data-bs-toggle="tooltip" title={item.isActive ? 'Deactivate' : 'Activate'}>
                                                                                <i class={`far fa-${item.isActive ? 'pause' : 'play'}`}></i>
                                                                            </button>
                                                                            <button
                                                                                onClick={() => deleteAvailabilityHandler(item.id)}
                                                                                class="btn ms-2 btn-outline-danger btn-sm rounded-2"
                                                                                data-bs-toggle="tooltip" title="Delete"><i
                                                                                    class="far fa-trash"></i></button>
                                                                            </>}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }) : (
                                                                <tr>
                                                                    <td colSpan="9" class="text-center py-5">
                                                                        <p>No availabilities found. <Link to={'/oneWayAvailabilities/add'} onClick={handleAddAvailabilityClick}>Add your first availability</Link></p>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                            {totalPages > 1 && (
                                                <div class="d-flex justify-content-between align-items-center mt-3">
                                                    <button
                                                        class="btn btn-outline-secondary"
                                                        onClick={() => setPage(prev => Math.max(1, prev - 1))}
                                                        disabled={page === 1}
                                                    >
                                                        Previous
                                                    </button>
                                                    <span>Page {page} of {totalPages}</span>
                                                    <button
                                                        class="btn btn-outline-secondary"
                                                        onClick={() => setPage(prev => Math.min(totalPages, prev + 1))}
                                                        disabled={page === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />

        {blockerModal}
    </>
    )
}
export default OneWayAvailabilities

